export default __webpack_public_path__ + "static/media/logo-pajakku-light.5cf66776.svg";